export default {
    bind(el, binding, vnode) {
        const dragDom = el;
        
        dragDom.style.cursor = 'move';
        dragDom.style.position = 'fixed';
        dragDom.style.zIndex = binding.value?.zIndex || 9999;
        
        let isDragging = false;
        let startX = 0;
        let startY = 0;
        let initialLeft = 0;
        let initialTop = 0;
        
        dragDom.addEventListener('mousedown', handleMouseDown);
        
        function handleMouseDown(e) {
            if (binding.value?.disabled) return;
            
            const target = e.target;
            const handle = binding.value?.handle;
            
            if (handle && !target.closest(handle)) return;
            
            isDragging = true;
            startX = e.clientX;
            startY = e.clientY;
            
            const rect = dragDom.getBoundingClientRect();
            initialLeft = rect.left;
            initialTop = rect.top;
            
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            
            e.preventDefault();
        }
        
        function handleMouseMove(e) {
            if (!isDragging) return;
            
            const deltaX = e.clientX - startX;
            const deltaY = e.clientY - startY;
            
            let newLeft = initialLeft + deltaX;
            let newTop = initialTop + deltaY;
            
            const boundary = binding.value?.boundary;
            if (boundary !== false) {
                const screenWidth = window.innerWidth;
                const screenHeight = window.innerHeight;
                const domWidth = dragDom.offsetWidth;
                const domHeight = dragDom.offsetHeight;
                
                newLeft = Math.max(0, Math.min(newLeft, screenWidth - domWidth));
                newTop = Math.max(0, Math.min(newTop, screenHeight - domHeight));
            }
            
            dragDom.style.left = newLeft + 'px';
            dragDom.style.top = newTop + 'px';
            
            if (binding.value?.onDrag) {
                binding.value.onDrag({ left: newLeft, top: newTop });
            }
        }
        
        function handleMouseUp() {
            isDragging = false;
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            
            if (binding.value?.onEnd) {
                const rect = dragDom.getBoundingClientRect();
                binding.value.onEnd({ left: rect.left, top: rect.top });
            }
        }
    },
    
    unbind(el) {
        el.removeEventListener('mousedown', el._dragHandler);
    }
}